import React from 'react'
import { Button, notification } from 'antd'

import { Route } from 'react-router-dom'
import { ItemList } from '~components'
import { PAGE_TYPES } from '~constants'
import { getCurrentUser } from '~context'

import { PageLayout } from '~stories'

import styles from './PagesList.module.css'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const PAGE_TYPE_OPTIONS = [
  { label: 'All', value: 'All' },
  ...PAGE_TYPES
]

const getEventNameWithLink = page => <a href={`/pages/${page._id}/edit`}>{String(page.name).toUpperCase()}</a>

const isUniversalTemplateExpired = page => {
  if (page?.type !== 'universal-template') return false
  if (page?.is_evergreen) return false
  if (!page?.expires_at) return false
  const pageMs = new Date(page.expires_at).getTime()
  if (Number.isNaN(pageMs)) return false
  return pageMs < Date.now()
}

const getPageRowClass = page =>
  isUniversalTemplateExpired(page) ? styles.expiredUniversalTemplateRow : ''

const expiredUniversalTemplateLegend = (
  <span className={styles.expiredLegend}>
    <span className={styles.expiredLegendSwatch} />
    Expired Pages
  </span>
)

const columnData = [
  {
    sorter: true,
    title: 'Title',
    dataIndex: 'name',
    render: (text, row) => getEventNameWithLink(row),
    width: '25%',
    sortDirections: ['descend', 'ascend', 'descend']
  },
  {
    dataIndex: 'slug',
    title: 'Slug',
    width: '30%'
  },
  {
    dataIndex: 'type',
    title: 'Type',
    width: '30%'
  }
]

const addNewPage = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/pages/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Page
      </Button>
    )} />
  )
}

const PagesList = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[
      addNewPage(isContentEditor)
    ]} title="Pages">
      <div className={styles.eventsLayoutBackground}>
        <ItemList
          columns={columnData}
          filterKey="type"
          filterOptions={PAGE_TYPE_OPTIONS}
          filterValue="All"
          paginationLegend={expiredUniversalTemplateLegend}
          resource='pages'
          rowClassName={getPageRowClass}
        />
      </div>
    </PageLayout>
  )
}

export default PagesList
